import{a as b}from"./ninox-components-KB6H56E3.js";import{a as n}from"./ninox-components-H6GS5QVK.js";import{l as t}from"./ninox-components-GQTCIGTF.js";import{m as h}from"./ninox-components-2ADN25D5.js";import{f as c}from"./ninox-components-DFJEWGV6.js";import{f as o}from"./ninox-components-MYF6AQNE.js";import{k as r}from"./ninox-components-R4FVH3NU.js";import{a as i}from"./ninox-components-I2GBTDK4.js";import d,{css as k}from"styled-components";var x=d(b)`
    align-items: center;
    justify-content: start;

    user-select: none;
    -webkit-tap-highlight-color: transparent;

    ${({label:e,theme:l})=>!n(e)&&k`
            color: ${l.text.primary};
            font-size: ${r.medium};
            font-weight: ${i.normal};
        `}
`,f=d.input`
    flex-shrink: 0;
    position: relative;

    display: inline-flex;
    box-sizing: content-box;

    height: var(--_check-box-size);
    width: var(--_check-box-size);
    margin: 0;

    --_check-box-size: var(--check-box-size, ${t.xxs});
    --_check-size: var(--check-size, calc(var(--_check-box-size) * 3 / 5));
    --_check-stroke: var(--check-stroke, max(${o.small}, calc(var(--_check-size) / 4)));
    --_check-ratio: var(--check-ratio, 2 / 3);

    --_check-rotation: 45deg;
    --_check-inline-size: calc(var(--_check-size) * var(--_check-ratio));

    background-color: ${({theme:e})=>e.checkbox.unchecked.default.box};
    outline-color: ${({theme:e})=>e.checkbox.unchecked.default.outline};
    outline-width: ${o.tiny};
    outline-style: solid;
    outline-offset: -${o.tiny};
    border-radius: ${c.medium};

    transition-property: background-color, outline-color, outline-offset;
    transition-timing-function: ease;
    transition-duration: 150ms;

    border: none;

    cursor: pointer;
    appearance: none;

    &:hover,
    &:active {
        background-color: ${({theme:e})=>e.checkbox.unchecked.hover.box};
        outline-color: ${({theme:e})=>e.checkbox.unchecked.hover.outline};
    }

    &:focus-visible {
        background-color: ${({theme:e})=>e.checkbox.unchecked.focusVisible.box};
        outline-color: ${({theme:e})=>e.checkbox.unchecked.focusVisible.outline};
    }

    &:disabled {
        cursor: default;
        background-color: ${({theme:e})=>e.checkbox.unchecked.disabled.box};
        outline-color: ${({theme:e})=>e.checkbox.unchecked.disabled.outline};
    }

    &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        box-sizing: border-box;

        height: var(--_check-size);
        width: var(--_check-inline-size);

        border-color: ${({theme:e})=>e.checkbox.unchecked.default.check};
        border-width: 0;
        border-style: solid;
        border-radius: ${c.small};

        transform-origin: 50% 50%;
        transform: translate(-50%, -50%)
            translate(0, calc((var(--_check-inline-size) - var(--_check-stroke)) / -2 * cos(var(--_check-rotation))))
            rotate(var(--_check-rotation));
        transition-property: border-width, transform;
        transition-timing-function: ease;
        transition-duration: 150ms;
    }

    &:hover:before,
    &:active:before,
    &:focus-visible:before {
        border-right-width: var(--_check-stroke);
        border-bottom-width: var(--_check-stroke);
    }

    &:hover:before,
    &:active:before {
        border-color: ${({theme:e})=>e.checkbox.unchecked.hover.check};
    }

    &:focus-visible:before {
        border-color: ${({theme:e})=>e.checkbox.unchecked.focusVisible.check};
    }

    &:disabled:before {
        border-color: ${({theme:e})=>e.checkbox.unchecked.disabled.check};
        border-right-width: var(--_check-stroke);
        border-bottom-width: var(--_check-stroke);
    }

    &:checked {
        background-color: ${({theme:e})=>e.checkbox.checked.default.box};
        outline-color: ${({theme:e})=>e.checkbox.checked.default.outline};

        &:hover,
        &:active {
            background-color: ${({theme:e})=>e.checkbox.checked.hover.box};
            outline-color: ${({theme:e})=>e.checkbox.checked.hover.outline};
        }

        &:focus-visible {
            background-color: ${({theme:e})=>e.checkbox.checked.focusVisible.box};
            outline-color: ${({theme:e})=>e.checkbox.checked.focusVisible.outline};
            outline-offset: ${h.thin};
        }

        &:disabled {
            background-color: ${({theme:e})=>e.checkbox.checked.disabled.box};
            outline-color: ${({theme:e})=>e.checkbox.checked.disabled.outline};
        }

        &:before {
            border-color: ${({theme:e})=>e.checkbox.checked.default.check};
            border-right-width: var(--_check-stroke);
            border-bottom-width: var(--_check-stroke);
        }

        &:hover:before,
        &:active:before {
            border-color: ${({theme:e})=>e.checkbox.checked.hover.check};
        }

        &:focus-visible:before {
            border-color: ${({theme:e})=>e.checkbox.checked.focusVisible.check};
        }

        &:disabled:before {
            border-color: ${({theme:e})=>e.checkbox.checked.disabled.check};
        }
    }

    &:indeterminate {
        --_check-inline-size: 0px;
        --_check-rotation: 90deg;

        &:before {
            border-right-width: var(--_check-stroke);
            border-bottom-width: 0;
        }

        &:required {
            background-color: ${({theme:e})=>e.checkbox.invalid.box};
            outline-color: ${({theme:e})=>e.checkbox.invalid.outline};
        }

        &:required:before {
            border-color: ${({theme:e})=>e.checkbox.invalid.check};
        }
    }
`;export{x as a,f as b};
//# sourceMappingURL=ninox-components-MP4ES4UI.js.map